import { restRequest } from 'config/rest-client';

/**
 * @deprecated this function will be replaced wen all the pending screens are migrated.
 */
export const unsuscribe = async (payload: any) => restRequest('/v1/contacts/unsubscribe/', {
  method: 'POST',
  body: payload,
});

export default { unsuscribe };
